import React from 'react';
import styles from '../../profile-page/pages/verify-otp/VerifyOtpPage.module.scss';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import popClose from 'assets/images/pop-close.svg';
import Label from '../../../constants/Label';

function ModalExampleCloseIcon(props) {
  const value = props.open;
  const [open, setOpen] = React.useState(value);
  return (
    <Modal
      className={styles.dialogue}
      closeIcon
      open={open}
      trigger={<input type="submit" value="Verify" className={styles.LoginPage__link} />}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    >
      <Header icon="warring" content="Invalid Message" />
      <Modal.Content className={styles.dialogue__wrap}>
        <p> {Label.Modal.ModalText}</p>
      </Modal.Content>
      <Modal.Actions className={styles.dialogue__buttons}>
        <Button color="red" onClick={() => setOpen(false)}>
          <Icon name="remove" /> No
        </Button>
        <Button color="green" onClick={() => setOpen(false)}>
          <Icon name="checkmark" /> Yes
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ModalExampleCloseIcon;
